const PATH = process.env.PUBLIC_URL;

export const POWERED_BY_LOGO = `${PATH}/images/logo.png`;



// WEBPACK FOOTER //
// ./src/constants/assets.js